import { generatePath, Params } from 'react-router-dom';

function getRoutePath(path: string, params?: Params<string>): string {
    return generatePath(path, params);
}

export { getRoutePath };
